import React from 'react';
import { ShieldCheckIcon, MailIcon, PhoneIcon, MapPinIcon } from 'lucide-react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="relative py-12 px-4 sm:px-6 lg:px-8 overflow-hidden bg-black border-t border-zinc-900" data-id="element-163">
      <div className="max-w-7xl mx-auto" data-id="element-164">
        {/* CTA Section */}
        <div className="text-center mb-16 pb-12 border-b border-zinc-900" data-id="element-165">
          <a href="/application" className="inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-black bg-white rounded-lg hover:bg-zinc-100 transition-all duration-200 shadow-lg hover:shadow-xl" data-id="element-166">
            Get Started Now
          </a>
        </div>

        <div className="grid md:grid-cols-4 gap-12 mb-12" data-id="element-167">
          {/* Column 1: Company */}
          <div data-id="element-168">
            <h3 className="text-1xl font-bold mb-6 text-white tracking-tight" data-id="element-169">
              VCA CAPITAL ADVISORS
            </h3>
            <p className="text-white mb-6 text-sm leading-relaxed max-w-xs" data-id="element-170">
              Empowering businesses with flexible capital solutions.
            </p>
            <div className="flex items-center gap-2 text-sm text-zinc-500" data-id="element-171">
              <ShieldCheckIcon className="w-5 h-5 text-white" data-id="element-172" />
              <span data-id="element-173">Secure & Confidential</span>
            </div>
          </div>

          {/* Column 2: Quick Links */}
          <div data-id="element-174">
            <h4 className="font-bold text-lg mb-6 text-white" data-id="element-175">Quick Links</h4>
            <ul className="space-y-3 text-zinc-400 text-sm" data-id="element-176">
              <li data-id="element-177">
                <a href="#" className="hover:text-white transition-colors" data-id="element-178">
                  Home
                </a>
              </li>
              <li data-id="element-179">
                <a href="#about" className="hover:text-white transition-colors" data-id="element-180">
                  About Us
                </a>
              </li>
              <li data-id="element-181">
                <a href="#how-it-works" className="hover:text-white transition-colors" data-id="element-182">
                  How It Works
                </a>
              </li>
              <li data-id="element-183">
                <a href="#faq" className="hover:text-white transition-colors" data-id="element-184">
                  FAQ
                </a>
              </li>
            </ul>
          </div>

          {/* Column 3: Funding Types */}
          <div data-id="element-185">
            <h4 className="font-bold text-lg mb-6 text-white" data-id="element-186">
              Funding Options
            </h4>
            <ul className="space-y-3 text-zinc-400 text-sm" data-id="element-187">
              <li data-id="element-188">
                <a href="#" className="hover:text-white transition-colors" data-id="element-189">
                  SBA Loans
                </a>
              </li>
              <li data-id="element-190">
                <a href="#" className="hover:text-white transition-colors" data-id="element-191">
                  Business Lines of Credit
                </a>
              </li>
              <li data-id="element-192">
                <a href="#" className="hover:text-white transition-colors" data-id="element-193">
                  Equipment Financing
                </a>
              </li>
              <li data-id="element-194">
                <a href="#" className="hover:text-white transition-colors" data-id="element-195">
                  Working Capital
                </a>
              </li>
              <li data-id="element-196">
                <a href="#" className="hover:text-white transition-colors" data-id="element-197">
                  Merchant Cash Advance
                </a>
              </li>
            </ul>
          </div>

          {/* Column 4: Contact Us */}
          <div data-id="element-198">
            <h4 className="font-bold text-lg mb-6 text-white" data-id="element-199">Contact Us</h4>
            <ul className="space-y-4 text-sm" data-id="element-200">
              <li data-id="element-201">
                <a href="mailto:info@vcacapitaladvisors.com" className="flex items-start gap-3 text-zinc-400 hover:text-white transition-colors" data-id="element-202">
                  <MailIcon className="w-4 h-4 text-white mt-0.5 shrink-0" data-id="element-203" />
                  info@vcacapitaladvisors.com
                </a>
              </li>
              <li data-id="element-204">
                <a href="tel:929-816-6805" className="flex items-start gap-3 text-zinc-400 hover:text-white transition-colors" data-id="element-205">
                  <PhoneIcon className="w-4 h-4 text-white mt-0.5 shrink-0" data-id="element-206" />
                  (929) 816-6805
                </a>
              </li>
              <li data-id="element-207">
                <div className="flex items-start gap-3 text-zinc-400" data-id="element-208">
                  <MapPinIcon className="w-4 h-4 text-white mt-0.5 shrink-0" data-id="element-209" />
                  <span data-id="element-210">
                    1221 Brickell Ave STE 900
                    <br data-id="element-211" />
                    Miami, FL 33131
                  </span>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-zinc-900 pt-8 flex flex-col justify-center items-center text-xs text-white space-y-2" data-id="element-212">
          <p data-id="element-213">© {currentYear} VCA Capital Advisors. All rights reserved.</p>
          <p className="text-zinc-500" data-id="element-214">
            VCA Capital Advisors is a DBA of Vantage Capital Group, LLC.
          </p>
          <div className="flex space-x-8" data-id="element-215">
            <a href="/privacy" className="hover:text-zinc-300 transition-colors" data-id="element-216">
              Privacy Policy
            </a>
            <a href="/terms" className="hover:text-zinc-300 transition-colors" data-id="element-217">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}